module.exports = __webpack_public_path__ + "img/293c01a.jpg";